import { FlyLoader } from '@fly/shared-ui';

export const LoginCallback = () => {
  return <FlyLoader />;
};
